import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';

import OcrIngestionContainer from '../../containers/ocr/OcrIngestion';
import ResourceUploader from '../form/ResourceUploader';
import Button from '@material-ui/core/Button';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';

import Note from '../../components/ui/Note';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 50px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
});

class OcrDocumentUploadDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
			closingIn: 4,
		};
	}

	handleDataFileUpload = ({ resource }) => {
		const documentResourceId = resource.resourceId;
		const { ocrIngestionAdd, showErrors, isUploadingRackTransfer, isUploadingInvoiceV2 } = this.props;

		this.setState({ isSaving: true, savingSuccessful: false });

		ocrIngestionAdd({
			params: {
				accountingCategory: 'ar',
				isUploadingRackTransfer,
				isUploadingInvoiceV2,
				documentResourceId,
			},
			callback: (err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				this.setState({
					isSaving: false,
					savingSuccessful: true,
				});
				this.props.onAfterSave();
			},
		});
	};

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.closingIn === 0 && prevState.closingIn === 1) {
			this.handleClose();
		}
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			checked: this.getValue(path, false),
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { classes, fullScreen, open, isUploadingRackTransfer, isUploadingInvoiceV2 } = this.props;

		const { isSaving, savingSuccessful } = this.state;

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					{isUploadingRackTransfer ? (
						<>
							<DialogTitle style={{ paddingBottom: 5 }}>
								Upload Rack Transfer Docs for OCR Ingestion
							</DialogTitle>
							<div>
								<Note>
									This is the current list of rack transfer documents we support for automated
									detection.
									<ul>
										<li>Superior Tank Lines Carrier Ticket</li>
										<li>MCJ Carrier Ticket</li>
										<li>Shell Carson BOL</li>
										<li>AltAir Paramount BOL</li>
									</ul>
								</Note>
							</div>
						</>
					) : isUploadingInvoiceV2 ? (
						<>
							<DialogTitle style={{ paddingBottom: 5 }}>
								Upload Invoice V2 Docs for OCR Ingestion
							</DialogTitle>
							<div>
								<Note>
									Use this for the new digital Superior Tanklines carrier delivery ticket format
									(sukl ID # format) and its attached BOLs.
									<ul>
										<li>Superior Tanklines Carrier Ticket (new digital format)</li>
										<li>IECFT Pickup BOL</li>
										<li>MHX Biofuel Pickup BOL</li>
									</ul>
								</Note>
							</div>
						</>
					) : (
						<>
							<DialogTitle style={{ paddingBottom: 5 }}>
								Upload Invoice Docs for OCR Ingestion
							</DialogTitle>
							<div>
								<Note>
									This is the current list of rack transfer documents we support for automated
									detection.
									<ul>
										<li>Superior Tank Lines Carrier Ticket (v1 and v2)</li>
										<li>Petro Diamond BOL</li>
										<li>World Energy BOL</li>
										<li>IECFT - USDG BOL</li>
										<li>MHX Fontana BOL</li>
									</ul>
								</Note>
							</div>
						</>
					)}
					<DialogContent>
						<ResourceUploader
							name={'dataFileResourceId'}
							label={''}
							afterUpload={this.handleDataFileUpload}
							// onlyOne={true}
							//stayOnSuccessAfterUpload={true}
						/>
					</DialogContent>

					<div style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button variant="contained" onClick={this.handleClose}>
							Close
						</Button>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>
									Upload successful and now processing documents. Upload more or close.
								</span>
							</div>
						</Zoom>
					</div>
				</div>
			</Dialog>
		);
	}
}

OcrDocumentUploadDialog.propTypes = {
	ocrIngestionAdd: PropTypes.func.isRequired,
	onAfterSave: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors: PropTypes.func,
	isUploadingRackTransfer: PropTypes.bool.isRequired,
	isUploadingInvoiceV2: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog(), OcrIngestionContainer])(
	OcrDocumentUploadDialog
);
